import { render, staticRenderFns } from "./header-publish-widget.vue?vue&type=template&id=487bb6dd&"
import script from "./header-publish-widget.vue?vue&type=script&lang=js&"
export * from "./header-publish-widget.vue?vue&type=script&lang=js&"
import style0 from "./header-publish-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports